export const TREATMENT_RUNTIME_BROADCAST_CHANNEL = "welliemd-treatment-runtime-v2";

export const createTreatmentRuntimeChannel = (onMessage) => {
  if (typeof globalThis.BroadcastChannel !== "function") return null;
  const channel = new globalThis.BroadcastChannel(
    TREATMENT_RUNTIME_BROADCAST_CHANNEL,
  );
  channel.addEventListener("message", onMessage);
  return channel;
};

export const closeTreatmentRuntimeChannel = (channel, onMessage) => {
  if (!channel) return;
  channel.removeEventListener("message", onMessage);
  channel.close();
};

export const treatmentRuntimeRevision = (session) => Number(
  session?.session_revision ?? -1,
);

export const isNewerTreatmentRuntimeProjection = (candidate, current) => (
  candidate?.session_token
  && current?.session_token
  && candidate.session_token === current.session_token
  && treatmentRuntimeRevision(candidate) > treatmentRuntimeRevision(current)
);
